/* cspell:disable -- Environment config contains API keys and tokens with word fragments */
import { DeploymentEnvironmentName } from "./types";

// eslint-disable-next-line no-restricted-syntax
export enum EnvironmentVariableKeys {
  REACT_APP_ADMIN_APP_CLIENT_URL = "REACT_APP_ADMIN_APP_CLIENT_URL",
  REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID = "REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID",
  REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN = "REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN",
  REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY = "REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY",
  REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID = "REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID",
  REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT = "REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT",
  REACT_APP_API_MAIN_URL = "REACT_APP_API_MAIN_URL",
  REACT_APP_ATTENDANCE_SCORE_SERVICE_URL = "REACT_APP_ATTENDANCE_SCORE_SERVICE_URL",
  REACT_APP_BASE_API_URL = "REACT_APP_BASE_API_URL",
  REACT_APP_CHECKR_DASHBOARD_URL = "REACT_APP_CHECKR_DASHBOARD_URL",
  REACT_APP_CLIPBOARD_BOTS_URL = "REACT_APP_CLIPBOARD_BOTS_URL",
  REACT_APP_CLIPBOARD_HIRING_BASE_URL = "REACT_APP_CLIPBOARD_HIRING_BASE_URL",
  REACT_APP_DOCUMENTS_SERVICE_REST_API_URL = "REACT_APP_DOCUMENTS_SERVICE_REST_API_URL",
  REACT_APP_DOCUMENTS_SERVICE_URL = "REACT_APP_DOCUMENTS_SERVICE_URL",
  REACT_APP_ENVIRONMENT_NAME = "REACT_APP_ENVIRONMENT_NAME",
  REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK = "REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK",
  REACT_APP_GOOGLE_MAP_API = "REACT_APP_GOOGLE_MAP_API",
  REACT_APP_HOME_HEALTH_API_URL = "REACT_APP_HOME_HEALTH_API_URL",
  REACT_APP_KNOCK_PUBLIC_API_KEY = "REACT_APP_KNOCK_PUBLIC_API_KEY",
  REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID = "REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID",
  REACT_APP_LICENSE_MANAGER_SERVICE_URL = "REACT_APP_LICENSE_MANAGER_SERVICE_URL",
  REACT_APP_MUI_LICENSE_KEY = "REACT_APP_MUI_LICENSE_KEY",
  REACT_APP_PAYMENTS_API_URL = "REACT_APP_PAYMENTS_API_URL",
  REACT_APP_SENDBIRD_APP_ID = "REACT_APP_SENDBIRD_APP_ID",
  REACT_APP_SHIFT_REVIEW_API_URL = "REACT_APP_SHIFT_REVIEW_API_URL",
  REACT_APP_SHIFT_VERIFICATION_BASE_URL = "REACT_APP_SHIFT_VERIFICATION_BASE_URL",
  REACT_APP_WORKER_APP_URL = "REACT_APP_WORKER_APP_URL",
  REACT_APP_WORKER_SERVICE_URL = "REACT_APP_WORKER_SERVICE_URL",
  REACT_APP_WORKPLACE_APP_URL = "REACT_APP_WORKPLACE_APP_URL",
  REACT_APP_IMPERSONATION_APP_CLIENT_ID = "REACT_APP_IMPERSONATION_APP_CLIENT_ID",
  REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS = "REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS",
  REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK = "REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK",
  REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN = "REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN",
  REACT_APP_RADAR_TRIP_SEARCH_PATH = "REACT_APP_RADAR_TRIP_SEARCH_PATH",
  REACT_APP_PUBLIC_ASSETS_BASE_URL = "REACT_APP_PUBLIC_ASSETS_BASE_URL",
  REACT_APP_COGNITO_OAUTH_DOMAIN = "REACT_APP_COGNITO_OAUTH_DOMAIN",
}

export const knock = {
  channels: {
    workplaceApns: "10d97173-2a44-48bf-8b91-74de04337321",
    workplaceFcm: "324c3485-1463-4f60-b9fe-b3c64b2b9b9b",
    guides: "2e75bc86-9c6e-43f5-8be3-6f8982c52834",
  },
  publicApiKeys: {
    default: "pk_test_fHsyGHBymviITpsPN_kSwmnr6ZkUX3155aa04PsDOJ4",
    local: "pk_test_iQzr5lBZUfaA0op1GSqI5Vipe4v0utcGIswBxtKhTss",
    development: "pk_test_iNomA7Kbb8oxErTNDvJxyt1mWgdQGZGg3kta36cW4Gs",
    staging: "pk_test_3Zf5dYYwQZPCsJY3FlXlUAKUiZRuLgNEUNSACGC0UTc",
    prodShadow: "pk_test_wi6bzWGa1GAxvJ-iIXic0Tn62dlEkOdcoSkyGZqFEME",
    production: "pk_YCD6_iDIJ1wcv0LAZv8uW1kCeDV630qj2aLtCN9UXDw",
  },
};

type Environments = Record<DeploymentEnvironmentName, Record<EnvironmentVariableKeys, string>>;

const environmentConfigs: Environments = {
  [DeploymentEnvironmentName.LOCAL]: {
    REACT_APP_ADMIN_APP_CLIENT_URL:
      process.env.REACT_APP_ADMIN_APP_CLIENT_URL ??
      "https://admin-webapp.development.clipboardhealth.org",
    REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID:
      process.env.REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID ??
      "0df687d0-5112-40f3-a7e6-a591f9f5ec78",
    REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN:
      process.env.REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN ?? "pube1f1a3b7e8059aff58b447323e31a1f5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY:
      process.env.REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY ?? "f1a21129-7b8f-48ee-8988-c2e9fc7534c5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID:
      process.env.REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID ??
      "web.org.clipboardhealth.aws.admin-webapp.development",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT:
      process.env.REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT ?? "sdk.iad-05.braze.com",
    REACT_APP_API_MAIN_URL: process.env.REACT_APP_API_MAIN_URL ?? "http://localhost:5000",
    REACT_APP_ATTENDANCE_SCORE_SERVICE_URL:
      process.env.REACT_APP_ATTENDANCE_SCORE_SERVICE_URL ??
      "https://apigateway.development.clipboardhealth.org/attendance-policy",
    REACT_APP_BASE_API_URL: process.env.REACT_APP_BASE_API_URL ?? "http://localhost:5000/api",
    REACT_APP_CHECKR_DASHBOARD_URL: "https://dashboard.checkrhq-staging.net",
    REACT_APP_CLIPBOARD_BOTS_URL:
      process.env.REACT_APP_CLIPBOARD_BOTS_URL ??
      "https://apigateway.development.clipboardhealth.org/clipboard-bots",
    REACT_APP_CLIPBOARD_HIRING_BASE_URL: "http://localhost:5001",
    REACT_APP_DOCUMENTS_SERVICE_REST_API_URL:
      process.env.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL ??
      "https://apigateway.development.clipboardhealth.org/docs/api",
    REACT_APP_DOCUMENTS_SERVICE_URL:
      process.env.REACT_APP_DOCUMENTS_SERVICE_URL ??
      "https://apigateway.development.clipboardhealth.org/docs/graphql",
    REACT_APP_ENVIRONMENT_NAME:
      process.env.REACT_APP_ENVIRONMENT_NAME ?? DeploymentEnvironmentName.DEVELOPMENT,
    REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK:
      process.env.REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK ??
      "https://support.clipboardhealth.com/hc/en-us/categories/4943215926167-Facilities",
    REACT_APP_GOOGLE_MAP_API:
      process.env.REACT_APP_GOOGLE_MAP_API ?? "AIzaSyB-bdCTToKwSEqEY-nLsHZ3cK33KXwSWEY",
    REACT_APP_HOME_HEALTH_API_URL:
      process.env.REACT_APP_HOME_HEALTH_API_URL ??
      "https://apigateway.development.clipboardhealth.org/home-health-api/api",
    REACT_APP_KNOCK_PUBLIC_API_KEY:
      process.env.REACT_APP_KNOCK_PUBLIC_API_KEY ?? knock.publicApiKeys.local,
    REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID:
      process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID ?? "630f2bba0ae37a11f535a61e",
    REACT_APP_LICENSE_MANAGER_SERVICE_URL:
      process.env.REACT_APP_LICENSE_MANAGER_SERVICE_URL ??
      "https://apigateway.development.clipboardhealth.org/license-manager",
    REACT_APP_MUI_LICENSE_KEY:
      process.env.REACT_APP_MUI_LICENSE_KEY ??
      "b4f2626b644ab823001978895141bce4Tz0xMjUyNzcsRT0xODAxNzg1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
    REACT_APP_PAYMENTS_API_URL:
      process.env.REACT_APP_PAYMENTS_API_URL ??
      "https://apigateway.development.clipboardhealth.org/payment",
    REACT_APP_SENDBIRD_APP_ID:
      process.env.REACT_APP_SENDBIRD_APP_ID ?? "F35ACEA9-2248-44DC-A448-73DCCB3FC17E",
    REACT_APP_SHIFT_REVIEW_API_URL:
      process.env.REACT_APP_SHIFT_REVIEW_API_URL ??
      "https://apigateway.development.clipboardhealth.org/reviews",
    REACT_APP_SHIFT_VERIFICATION_BASE_URL:
      process.env.REACT_APP_SHIFT_VERIFICATION_BASE_URL ??
      "https://shiftverification.development.clipboardhealth.org",
    REACT_APP_WORKER_APP_URL: process.env.REACT_APP_WORKER_APP_URL ?? "http://localhost:4300",
    REACT_APP_WORKER_SERVICE_URL:
      process.env.REACT_APP_WORKER_SERVICE_URL ??
      "https://apigateway.development.clipboardhealth.org/worker",
    REACT_APP_WORKPLACE_APP_URL:
      process.env.REACT_APP_WORKPLACE_APP_URL ??
      "https://admin-webapp.development.clipboardhealth.org",
    REACT_APP_IMPERSONATION_APP_CLIENT_ID: process.env.REACT_APP_IMPERSONATION_APP_CLIENT_ID ?? "",
    REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS:
      process.env.REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS ?? "60",
    REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK:
      process.env.REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK ??
      "https://go.clipboardworks.com/sign-new-agreement",
    REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN: "https://970533.apps.zdusercontent.com",
    REACT_APP_RADAR_TRIP_SEARCH_PATH:
      "https://radar.com/dashboard/geofencing/trips?project=62837e8e1444c6005e98e771&live=false&externalId=",
    REACT_APP_PUBLIC_ASSETS_BASE_URL: "https://d29i6muigr8khi.cloudfront.net",
    REACT_APP_COGNITO_OAUTH_DOMAIN:
      process.env.REACT_APP_COGNITO_OAUTH_DOMAIN ??
      "clipboard-development.auth.us-west-2.amazoncognito.com",
  },
  [DeploymentEnvironmentName.DEVELOPMENT]: {
    REACT_APP_ADMIN_APP_CLIENT_URL: "https://admin-webapp.development.clipboardhealth.org",
    REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID: "0df687d0-5112-40f3-a7e6-a591f9f5ec78",
    REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN: "pube1f1a3b7e8059aff58b447323e31a1f5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY: "f1a21129-7b8f-48ee-8988-c2e9fc7534c5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID: "web.org.clipboardhealth.aws.admin-webapp.development",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT: "sdk.iad-05.braze.com",
    REACT_APP_API_MAIN_URL: "https://apigateway.development.clipboardhealth.org",
    REACT_APP_ATTENDANCE_SCORE_SERVICE_URL:
      "https://apigateway.development.clipboardhealth.org/attendance-policy",
    REACT_APP_BASE_API_URL: "https://apigateway.development.clipboardhealth.org/api",
    REACT_APP_CHECKR_DASHBOARD_URL: "https://dashboard.checkrhq-staging.net",
    REACT_APP_CLIPBOARD_BOTS_URL:
      process.env.REACT_APP_CLIPBOARD_BOTS_URL ??
      "https://apigateway.development.clipboardhealth.org/clipboard-bots",
    REACT_APP_CLIPBOARD_HIRING_BASE_URL: "https://worker-jobs.development.clipboardhealth.org",
    REACT_APP_DOCUMENTS_SERVICE_REST_API_URL:
      "https://apigateway.development.clipboardhealth.org/docs/api",
    REACT_APP_DOCUMENTS_SERVICE_URL:
      "https://apigateway.development.clipboardhealth.org/docs/graphql",
    REACT_APP_ENVIRONMENT_NAME: DeploymentEnvironmentName.DEVELOPMENT,
    REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK:
      "https://support.clipboardhealth.com/hc/en-us/categories/4943215926167-Facilities",
    REACT_APP_GOOGLE_MAP_API: "AIzaSyB-bdCTToKwSEqEY-nLsHZ3cK33KXwSWEY",
    REACT_APP_HOME_HEALTH_API_URL:
      "https://apigateway.development.clipboardhealth.org/home-health-api/api",
    REACT_APP_KNOCK_PUBLIC_API_KEY: knock.publicApiKeys.development,
    REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID: "630f2bba0ae37a11f535a61e",
    REACT_APP_LICENSE_MANAGER_SERVICE_URL:
      "https://apigateway.development.clipboardhealth.org/license-manager",
    REACT_APP_MUI_LICENSE_KEY:
      "b4f2626b644ab823001978895141bce4Tz0xMjUyNzcsRT0xODAxNzg1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
    REACT_APP_PAYMENTS_API_URL: "https://apigateway.development.clipboardhealth.org/payment",
    REACT_APP_SENDBIRD_APP_ID: "F35ACEA9-2248-44DC-A448-73DCCB3FC17E",
    REACT_APP_SHIFT_REVIEW_API_URL: "https://apigateway.development.clipboardhealth.org/reviews",
    REACT_APP_SHIFT_VERIFICATION_BASE_URL:
      "https://shiftverification.development.clipboardhealth.org",
    REACT_APP_WORKER_APP_URL: "https://hcp-webapp.development.clipboardhealth.org",
    REACT_APP_WORKER_SERVICE_URL: "https://apigateway.development.clipboardhealth.org/worker",
    REACT_APP_WORKPLACE_APP_URL: "https://admin-webapp.development.clipboardhealth.org",
    REACT_APP_IMPERSONATION_APP_CLIENT_ID: "3p5v1tuijmi79091l7tvn6v918",
    REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS: "60",
    REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK:
      process.env.REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK ??
      "https://go.clipboardworks.com/sign-new-agreement",
    REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN: "https://970533.apps.zdusercontent.com",
    REACT_APP_RADAR_TRIP_SEARCH_PATH:
      "https://radar.com/dashboard/geofencing/trips?project=62837e8e1444c6005e98e771&live=false&externalId=",
    REACT_APP_PUBLIC_ASSETS_BASE_URL: "https://d29i6muigr8khi.cloudfront.net",
    REACT_APP_COGNITO_OAUTH_DOMAIN: "clipboard-development.auth.us-west-2.amazoncognito.com",
  },
  [DeploymentEnvironmentName.STAGING]: {
    REACT_APP_ADMIN_APP_CLIENT_URL: "https://admin-webapp.staging.clipboardhealth.org",
    REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID: "0df687d0-5112-40f3-a7e6-a591f9f5ec78",
    REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN: "pube1f1a3b7e8059aff58b447323e31a1f5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY: "f1a21129-7b8f-48ee-8988-c2e9fc7534c5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID: "web.org.clipboardhealth.aws.admin-webapp.development",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT: "sdk.iad-05.braze.com",
    REACT_APP_API_MAIN_URL: "https://apigateway.staging.clipboardhealth.org",
    REACT_APP_ATTENDANCE_SCORE_SERVICE_URL:
      "https://apigateway.staging.clipboardhealth.org/attendance-policy",
    REACT_APP_BASE_API_URL: "https://apigateway.staging.clipboardhealth.org/api",
    REACT_APP_CHECKR_DASHBOARD_URL: "https://dashboard.checkrhq-staging.net",
    REACT_APP_CLIPBOARD_BOTS_URL:
      process.env.REACT_APP_CLIPBOARD_BOTS_URL ??
      "https://apigateway.staging.clipboardhealth.org/clipboard-bots",
    REACT_APP_CLIPBOARD_HIRING_BASE_URL: "https://clipboardhiring.com",
    REACT_APP_DOCUMENTS_SERVICE_REST_API_URL:
      "https://apigateway.staging.clipboardhealth.org/docs/api",
    REACT_APP_DOCUMENTS_SERVICE_URL: "https://apigateway.staging.clipboardhealth.org/docs/graphql",
    REACT_APP_ENVIRONMENT_NAME: DeploymentEnvironmentName.STAGING,
    REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK:
      "https://support.clipboardhealth.com/hc/en-us/categories/4943215926167-Facilities",
    REACT_APP_GOOGLE_MAP_API: "AIzaSyB-bdCTToKwSEqEY-nLsHZ3cK33KXwSWEY",
    REACT_APP_HOME_HEALTH_API_URL:
      "https://apigateway.staging.clipboardhealth.org/home-health-api/api",
    REACT_APP_KNOCK_PUBLIC_API_KEY: knock.publicApiKeys.staging,
    REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID: "60d9bf072e18760d739e5f9a",
    REACT_APP_LICENSE_MANAGER_SERVICE_URL:
      "https://apigateway.staging.clipboardhealth.org/license-manager",
    REACT_APP_MUI_LICENSE_KEY:
      "b4f2626b644ab823001978895141bce4Tz0xMjUyNzcsRT0xODAxNzg1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
    REACT_APP_PAYMENTS_API_URL: "https://apigateway.staging.clipboardhealth.org/payment",
    REACT_APP_SENDBIRD_APP_ID: "F35ACEA9-2248-44DC-A448-73DCCB3FC17E",
    REACT_APP_SHIFT_REVIEW_API_URL: "https://apigateway.staging.clipboardhealth.org/reviews",
    REACT_APP_SHIFT_VERIFICATION_BASE_URL: "https://shiftverification.staging.clipboardhealth.org",
    REACT_APP_WORKER_APP_URL: "https://hcp-webapp.staging.clipboardhealth.org",
    REACT_APP_WORKER_SERVICE_URL: "https://apigateway.staging.clipboardhealth.org/worker",
    REACT_APP_WORKPLACE_APP_URL: "https://admin-webapp.staging.clipboardhealth.org",
    REACT_APP_IMPERSONATION_APP_CLIENT_ID: "44p7tckk3lcn5u5h20lo27g6e9",
    REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS: "60",
    REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK:
      process.env.REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK ??
      "https://go.clipboardworks.com/sign-new-agreement",
    REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN: "https://970533.apps.zdusercontent.com",
    REACT_APP_RADAR_TRIP_SEARCH_PATH:
      "https://radar.com/dashboard/geofencing/trips?project=62837e8e1444c6005e98e771&live=false&externalId=",
    REACT_APP_PUBLIC_ASSETS_BASE_URL: "https://d29i6muigr8khi.cloudfront.net",
    REACT_APP_COGNITO_OAUTH_DOMAIN: "clipboard-staging.auth.us-west-2.amazoncognito.com",
  },
  [DeploymentEnvironmentName.PROD_SHADOW]: {
    REACT_APP_ADMIN_APP_CLIENT_URL: "https://admin-webapp.prod-shadow.clipboardhealth.org",
    REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID: "0df687d0-5112-40f3-a7e6-a591f9f5ec78",
    REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN: "pube1f1a3b7e8059aff58b447323e31a1f5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY: "f1a21129-7b8f-48ee-8988-c2e9fc7534c5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID: "web.org.clipboardhealth.aws.admin-webapp.prod-shadow",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT: "sdk.iad-05.braze.com",
    REACT_APP_API_MAIN_URL: "https://apigateway.prod-shadow.clipboardhealth.org",
    REACT_APP_ATTENDANCE_SCORE_SERVICE_URL:
      "https://apigateway.prod-shadow.clipboardhealth.org/attendance-policy",
    REACT_APP_BASE_API_URL: "https://apigateway.prod-shadow.clipboardhealth.org/api",
    REACT_APP_CHECKR_DASHBOARD_URL: "https://dashboard.checkrhq-staging.net",
    REACT_APP_CLIPBOARD_BOTS_URL:
      process.env.REACT_APP_CLIPBOARD_BOTS_URL ??
      "https://apigateway.prod-shadow.clipboardhealth.org/clipboard-bots",
    REACT_APP_CLIPBOARD_HIRING_BASE_URL: "https://clipboardhiring.com",
    REACT_APP_DOCUMENTS_SERVICE_REST_API_URL:
      "https://apigateway.prod-shadow.clipboardhealth.org/docs/api",
    REACT_APP_DOCUMENTS_SERVICE_URL:
      "https://apigateway.prod-shadow.clipboardhealth.org/docs/graphql",
    REACT_APP_ENVIRONMENT_NAME: DeploymentEnvironmentName.PROD_SHADOW,
    REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK:
      "https://support.clipboardhealth.com/hc/en-us/categories/4943215926167-Facilities",
    REACT_APP_GOOGLE_MAP_API: "AIzaSyB-bdCTToKwSEqEY-nLsHZ3cK33KXwSWEY",
    REACT_APP_HOME_HEALTH_API_URL:
      "https://apigateway.prod-shadow.clipboardhealth.org/home-health-api/api",
    REACT_APP_KNOCK_PUBLIC_API_KEY: knock.publicApiKeys.prodShadow,
    REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID: "6470bf875947cf12f734ff1d",
    REACT_APP_LICENSE_MANAGER_SERVICE_URL:
      "https://apigateway.prod-shadow.clipboardhealth.org/license-manager",
    REACT_APP_MUI_LICENSE_KEY:
      "b4f2626b644ab823001978895141bce4Tz0xMjUyNzcsRT0xODAxNzg1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
    REACT_APP_PAYMENTS_API_URL: "https://apigateway.prod-shadow.clipboardhealth.org/payment",
    REACT_APP_SENDBIRD_APP_ID: "F35ACEA9-2248-44DC-A448-73DCCB3FC17E",
    REACT_APP_SHIFT_REVIEW_API_URL: "https://apigateway.prod-shadow.clipboardhealth.org/reviews",
    REACT_APP_SHIFT_VERIFICATION_BASE_URL:
      "https://shiftverification.prod-shadow.clipboardhealth.org",
    REACT_APP_WORKER_APP_URL: "https://hcp-webapp.prod-shadow.clipboardhealth.org",
    REACT_APP_WORKER_SERVICE_URL: "https://apigateway.prod-shadow.clipboardhealth.org/worker",
    REACT_APP_WORKPLACE_APP_URL: "https://admin-webapp.prod-shadow.clipboardhealth.org",
    REACT_APP_IMPERSONATION_APP_CLIENT_ID: "6ljr9n3firo1h6iddmmons7ltk",
    REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS: "60",
    REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK:
      process.env.REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK ??
      "https://go.clipboardworks.com/sign-new-agreement",
    REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN: "https://970533.apps.zdusercontent.com",
    REACT_APP_RADAR_TRIP_SEARCH_PATH:
      "https://radar.com/dashboard/geofencing/trips?project=62837e8e1444c6005e98e771&live=false&externalId=",
    REACT_APP_PUBLIC_ASSETS_BASE_URL: "https://d29i6muigr8khi.cloudfront.net",
    REACT_APP_COGNITO_OAUTH_DOMAIN: "clipboard-prod-shadow.auth.us-west-2.amazoncognito.com",
  },
  [DeploymentEnvironmentName.PROD_RECREATED]: {
    REACT_APP_ADMIN_APP_CLIENT_URL: "https://admin-webapp.prod-recreated.clipboardhealth.org",
    REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID: "0df687d0-5112-40f3-a7e6-a591f9f5ec78",
    REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN: "pube1f1a3b7e8059aff58b447323e31a1f5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY: "f1a21129-7b8f-48ee-8988-c2e9fc7534c5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID: "web.org.clipboardhealth.aws.admin-webapp.development",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT: "sdk.iad-05.braze.com",
    REACT_APP_API_MAIN_URL: "https://apigateway.prod-recreated.clipboardhealth.org",
    REACT_APP_ATTENDANCE_SCORE_SERVICE_URL:
      "https://apigateway.prod-recreated.clipboardhealth.org/attendance-policy",
    REACT_APP_BASE_API_URL: "https://apigateway.prod-recreated.clipboardhealth.org/api",
    REACT_APP_CHECKR_DASHBOARD_URL: "https://dashboard.checkrhq-staging.net",
    REACT_APP_CLIPBOARD_BOTS_URL:
      process.env.REACT_APP_CLIPBOARD_BOTS_URL ??
      "https://apigateway.prod-recreated.clipboardhealth.org/clipboard-bots",
    REACT_APP_CLIPBOARD_HIRING_BASE_URL: "https://clipboardhiring.com",
    REACT_APP_DOCUMENTS_SERVICE_REST_API_URL:
      "https://apigateway.prod-recreated.clipboardhealth.org/docs/api",
    REACT_APP_DOCUMENTS_SERVICE_URL:
      "https://apigateway.prod-recreated.clipboardhealth.org/docs/graphql",
    REACT_APP_ENVIRONMENT_NAME: DeploymentEnvironmentName.PROD_RECREATED,
    REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK:
      "https://support.clipboardhealth.com/hc/en-us/categories/4943215926167-Facilities",
    REACT_APP_GOOGLE_MAP_API: "AIzaSyB-bdCTToKwSEqEY-nLsHZ3cK33KXwSWEY",
    REACT_APP_HOME_HEALTH_API_URL:
      "https://apigateway.prod-recreated.clipboardhealth.org/home-health-api/api",
    REACT_APP_KNOCK_PUBLIC_API_KEY: knock.publicApiKeys.default,
    REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID: "60d9bf072e18760d739e5f9a",
    REACT_APP_LICENSE_MANAGER_SERVICE_URL:
      "https://apigateway.prod-recreated.clipboardhealth.org/license-manager",
    REACT_APP_MUI_LICENSE_KEY:
      "b4f2626b644ab823001978895141bce4Tz0xMjUyNzcsRT0xODAxNzg1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
    REACT_APP_PAYMENTS_API_URL: "https://apigateway.prod-recreated.clipboardhealth.org/payment",
    REACT_APP_SENDBIRD_APP_ID: "F35ACEA9-2248-44DC-A448-73DCCB3FC17E",
    REACT_APP_SHIFT_REVIEW_API_URL: "https://apigateway.prod-recreated.clipboardhealth.org/reviews",
    REACT_APP_SHIFT_VERIFICATION_BASE_URL:
      "https://shiftverification.prod-recreated.clipboardhealth.org",
    REACT_APP_WORKER_APP_URL: "https://hcp-webapp.prod-recreated.clipboardhealth.org",
    REACT_APP_WORKER_SERVICE_URL: "https://apigateway.prod-recreated.clipboardhealth.org/worker",
    REACT_APP_WORKPLACE_APP_URL: "https://admin-webapp.prod-recreated.clipboardhealth.org",
    REACT_APP_IMPERSONATION_APP_CLIENT_ID: "6ljr9n3firo1h6iddmmons7ltk",
    REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS: "60",
    REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK:
      process.env.REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK ??
      "https://go.clipboardworks.com/sign-new-agreement",
    REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN: "https://970533.apps.zdusercontent.com",
    REACT_APP_RADAR_TRIP_SEARCH_PATH:
      "https://radar.com/dashboard/geofencing/trips?project=62837e8e1444c6005e98e771&live=false&externalId=",
    REACT_APP_PUBLIC_ASSETS_BASE_URL: "https://d29i6muigr8khi.cloudfront.net",
    REACT_APP_COGNITO_OAUTH_DOMAIN: "clipboard-staging.auth.us-west-2.amazoncognito.com",
  },
  [DeploymentEnvironmentName.PRODUCTION]: {
    REACT_APP_ADMIN_APP_CLIENT_URL: "https://clipboard.health",
    REACT_APP_ADMIN_DATADOG_RUM_APPLICATION_ID: "0df687d0-5112-40f3-a7e6-a591f9f5ec78",
    REACT_APP_ADMIN_DATADOG_RUM_CLIENT_TOKEN: "pube1f1a3b7e8059aff58b447323e31a1f5",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY: "45e6e2cc-2bf5-44f3-9c65-06481190f5bf",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID: "web.org.clipboardhealth.aws.admin-webapp.production",
    REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT: "sdk.iad-05.braze.com",
    REACT_APP_API_MAIN_URL: "https://api.clipboard.health",
    REACT_APP_ATTENDANCE_SCORE_SERVICE_URL: "https://api.clipboard.health/attendance-policy",
    REACT_APP_BASE_API_URL: "https://api.clipboard.health/api",
    REACT_APP_CHECKR_DASHBOARD_URL: "https://dashboard.checkr.com",
    REACT_APP_CLIPBOARD_BOTS_URL:
      process.env.REACT_APP_CLIPBOARD_BOTS_URL ?? "https://api.clipboard.health/clipboard-bots",
    REACT_APP_CLIPBOARD_HIRING_BASE_URL: "https://clipboardhiring.com",
    REACT_APP_DOCUMENTS_SERVICE_REST_API_URL: "https://api.clipboard.health/docs/api",
    REACT_APP_DOCUMENTS_SERVICE_URL: "https://api.clipboard.health/docs/graphql",
    REACT_APP_ENVIRONMENT_NAME: DeploymentEnvironmentName.PRODUCTION,
    REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK:
      "https://support.clipboardhealth.com/hc/en-us/categories/4943215926167-Facilities",
    REACT_APP_GOOGLE_MAP_API: "AIzaSyBXEn-QsL2TbTelzYADPm12ssNB6-rxeyE",
    REACT_APP_HOME_HEALTH_API_URL: "https://api.clipboard.health/home-health-api/api",
    REACT_APP_KNOCK_PUBLIC_API_KEY: knock.publicApiKeys.production,
    REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID: "60c75392e1cd230bf4f1ca30",
    REACT_APP_LICENSE_MANAGER_SERVICE_URL: "https://api.clipboard.health/license-manager",
    REACT_APP_MUI_LICENSE_KEY:
      "b4f2626b644ab823001978895141bce4Tz0xMjUyNzcsRT0xODAxNzg1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
    REACT_APP_PAYMENTS_API_URL: "https://api.clipboard.health/payment",
    REACT_APP_SENDBIRD_APP_ID: "7C7019BD-5389-48A2-8BCA-353823B917AF",
    REACT_APP_SHIFT_REVIEW_API_URL: "https://api.clipboard.health/reviews",
    REACT_APP_SHIFT_VERIFICATION_BASE_URL: "https://shiftverification.prod.clipboardhealth.org",
    REACT_APP_WORKER_APP_URL: "https://hcp.clipboard.health",
    REACT_APP_WORKER_SERVICE_URL: "https://api.clipboard.health/worker",
    REACT_APP_WORKPLACE_APP_URL: "https://admin.clipboard.health",
    REACT_APP_IMPERSONATION_APP_CLIENT_ID: "4124rjua4ckk1morfbbeinniha",
    REACT_APP_WORKER_WORK_PLACE_TYPES_SYNC_TTL_SECONDS: "60",
    REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK:
      process.env.REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK ??
      "https://go.clipboardworks.com/sign-new-agreement",
    REACT_APP_ZENDESK_FRAME_ANCESTOR_ORIGIN: "https://989425.apps.zdusercontent.com",
    REACT_APP_RADAR_TRIP_SEARCH_PATH:
      "https://radar.com/dashboard/geofencing/trips?project=62837e8e1444c6005e98e771&live=true&externalId=",
    REACT_APP_PUBLIC_ASSETS_BASE_URL: "https://d1x6ey4ljstqh0.cloudfront.net",
    REACT_APP_COGNITO_OAUTH_DOMAIN: "clipboard-production.auth.us-west-2.amazoncognito.com",
  },
};

export function getEnvironmentConfig(environmentName: DeploymentEnvironmentName) {
  const selectedEnvironment = environmentConfigs[environmentName];
  return selectedEnvironment ?? environmentConfigs[DeploymentEnvironmentName.PRODUCTION];
}

export const environmentConfig = getEnvironmentConfig(
  process.env.REACT_APP_ENVIRONMENT_NAME as DeploymentEnvironmentName
);
